<template lang="pug">
.participant-address-section
  .form-col.large-24
    .address-active(v-if="address_when_playing_varsity.active")
      .row
        .form-col.large-12
          validation-provider(:rules="{ required: address_when_playing_varsity.required }" v-slot="{ errors }")
            span.required(v-if="address_when_playing_varsity.required") *
            label.required(:class="{ error: errors[0] }") {{ address_when_playing_varsity.name }}
            span.description(v-if="address_when_playing_varsity.description")
              | {{ address_when_playing_varsity.description }}
            input(
              type="text"
              placeholder="Enter line 1"
              v-model="varsity_info.participant_address.varisty_address.address_1"
              :class="{ error: errors[0] }"
            )
            
        .form-col.large-12
          label {{ t('app.registration.transfer_info.address_2') }}
          input(
            type="text"
            placeholder="Enter line 2"
            v-model="varsity_info.participant_address.varisty_address.address_2"
          )
      .row
        .form-col.large-8
          validation-provider(:rules="{ required: address_when_playing_varsity.required }" v-slot="{ errors }")
            span.required(v-if="address_when_playing_varsity.required") *
            label.required(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.city') }}
            input(
              type="text"
              placeholder="Enter city"
              v-model="varsity_info.participant_address.varisty_address.city"
              :class="{ error: errors[0] }"
            )
            
        .form-col.large-8
          validation-provider(:rules="{ required: address_when_playing_varsity.required }" v-slot="{ errors }")
            span.required(v-if="address_when_playing_varsity.required") *
            label(:class="{ error: errors[0] }") State
            select(
              v-model="varsity_info.participant_address.varisty_address.state"
              :class="{ error: errors[0] }"
            )
              option(value="" disabled selected) {{ t("app.buttons.select") }}
              option(v-for="state in states" :key="state" :value="state") {{ state }}
            
        .form-col.large-8
          validation-provider(:rules="{ required: address_when_playing_varsity.required }" v-slot="{ errors }")
            span.required(v-if="address_when_playing_varsity.required") *
            label.required(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.zip_postal_code') }}
            input(
              type="text"
              placeholder="Enter zip/postal code"
              v-model="varsity_info.participant_address.varisty_address.zip_postal_code"
              :class="{ error: errors[0] }"
            )
            
    .row
      .form-col.large-12(v-if="date_moved_to_address_above.active")
        span.required(v-if="date_moved_to_address_above.required") *
        validation-provider.field.clearfix.datepicker(
          v-slot="{ errors }"
          :rules="{ required: date_moved_to_address_above.required }"
          tag="div"
        ) 
          label.required(:class="{ error: errors[0] }") {{ date_moved_to_address_above.name }}
          span.description(v-if="date_moved_to_address_above.description")
            | {{ date_moved_to_address_above.description }}
          .input-group
            flat-pickr(
              placeholder="Select"
              class="large-6"
              :config="datePickerOpts"
              @input="onSelectDate($event, index)"
              v-model="varsity_info.participant_address.address_moved_date.date"
              :class="{ error: errors[0] }"
            )
            .prefix.date
              span.icon-calendar
          
      .form-col.large-12(v-if="phone_number_of_participant_family.active")
        validation-provider(:rules="{ required: phone_number_of_participant_family.required }" v-slot="{ errors }")
          span.required(v-if="phone_number_of_participant_family.required") *
          label.required(:class="{ error: errors[0] }") {{ phone_number_of_participant_family.name }}
          span.description(v-if="phone_number_of_participant_family.description")
            | {{ phone_number_of_participant_family.description }}
          phone(
            :required="true"
            :disabled="false"
            v-model="varsity_info.participant_address.participant_phone.number"
            :class="{ error: errors[0] }"
          )
          
    .row(v-if="school_district_of_address_above.active")
      .form-col.large-8
        validation-provider(:rules="{ required: school_district_of_address_above.required }" v-slot="{ errors }")
          span.required(v-if="school_district_of_address_above.required") *
          label.required(:class="{ error: errors[0] }") {{ school_district_of_address_above.name }}
          span.description(v-if="school_district_of_address_above.description")
            | {{ school_district_of_address_above.description }}
          input(
            type="text"
            placeholder="Enter school district"
            v-model="varsity_info.participant_address.school_district.name"
            :class="{ error: errors[0] }"
          )
          
</template>

<script>
import datepicker from '../../shared/_formatted_datepicker.vue';
import flatPickr from 'vue-flatpickr-component';
import phone from 'components/phone.vue';

export default {
  components: { datepicker, flatPickr, phone },
  props: ['varsity_info', 'nested_fields'],
  data() {
    return {
      datePickerOpts: {
        dateFormat: 'm-d-Y',
        allowInput: true,
      },
      currentState: '',
      states: [
        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
        "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM",
        "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
        "WV", "WI", "WY"
      ].sort(),
    };
  },
  computed: {
    address_when_playing_varsity(){
      return this.nested_fields.find(field => field.uid === 'address_when_playing_varsity') || {};
    },
    date_moved_to_address_above() {
      return this.nested_fields.find(field => field.uid === 'date_moved_to_address_above') || {};
    },
    phone_number_of_participant_family() {
      return this.nested_fields.find(field => field.uid === 'phone_number_of_participant_family') || {};
    },
    school_district_of_address_above() {
      return this.nested_fields.find(field => field.uid === 'school_district_of_address_above') || {};
    },
  },
  methods: {
    onPhoneChange(event) {
      console.log("Phone number changed:", event);
    },
    onSelectDate(date, index) {
      // Handle date selection logic here
      console.log("Selected date:", date, "at index:", index);
    },
  },
};
</script>